import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../shared/services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SampleService } from '../../core/http/sample.service';
import { SettingsService } from '../../core/http/settings.service';
import { BillingService } from '../../core/http/billing.service';
import { AuthServiceService } from '../../core/http/auth-service.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { RefundComponent } from '../../shared/components/refund/refund.component'
import {trigger, style, animate, transition, state} from '@angular/animations';
import * as _moment from 'moment';
const moment = _moment;


@Component({
  selector: 'app-print-receipt',
  templateUrl: './print-receipt.component.html',
  styleUrls: ['./print-receipt.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({transform: 'translateY(-100%)'}),
        animate('200ms ease-in', style({transform: 'translateY(0%)'}))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({transform: 'translateY(-100%)'}))
      ])
    ])
  ]
})
export class PrintReceiptComponent implements OnInit {

  isLoading = true;
  isSaveLoading = false
  mode = "form";
  Errors = null;
  data: any = [];
  samples: any = [];
  Success;
  billId;
  message;
  record: any= [];
  templates: any = [];
  startdate = "";
  enddate = "";
  receipt;
  payment: any = []
  recLoad: boolean = false;
  tempLoad: boolean = false;
  item: any = {}
  visible: boolean = false;
  name = "";
  role = localStorage.getItem('role');

  Template_Text = "";

  editorConfig: AngularEditorConfig = {
    editable: true,
      spellcheck: true,
      height: '300px',
      minHeight: '300px',
      maxHeight: '300px',
      width: 'auto',
      minWidth: 'auto',
      translate: 'yes',
      enableToolbar: true,
      showToolbar: true,
      placeholder: 'Enter text here...',
      defaultParagraphSeparator: '',
      defaultFontName: '',
      defaultFontSize: '',
      fonts: [
        {class: 'arial', name: 'Arial'},
        {class: 'times-new-roman', name: 'Times New Roman'},
        {class: 'calibri', name: 'Calibri'},
        {class: 'comic-sans-ms', name: 'Comic Sans MS'}
      ],
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      [
        'insertImage',
        'insertVideo',
        'insertHorizontalRule',
        'removeFormat',
      ]
    ],
};

  stateForm = new FormGroup({
    sample_id: new FormControl('', Validators.required),
    format_code: new FormControl(''),
    formatstr: new FormControl('', Validators.required),
    result_id: new FormControl(''),
  });



  constructor(public router: Router, private sample: SampleService, private modal: ModalService, private _snackBar: MatSnackBar, public setting: SettingsService, public auth: AuthServiceService, public bill:BillingService) { }

  ngOnInit(): void {
    let date = new Date()
    this.enddate = (moment(date).format('YYYY-MM-DD'))
    this.startdate = (moment(date).format('YYYY-MM-DD'))
    this.getPayments()

  }

  getPayments() {
    this.isLoading = true;
    this.sample
    .getPayment(this.startdate, this.enddate, this.name)
    .subscribe(
      (resSuccess) => {
        this.data = resSuccess
        this.isLoading = false;
        console.log(this.data);

      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    )
  }
  search() {
    this.getPayments()
  }
  // getResult() {
  //   this.sample
  //   .getResults(this.startdate, this.enddate)
  //   .subscribe(
  //     (resSuccess) => {
  //       this.data = resSuccess
  //     },
  //     (resErr) => {
  //       this.Errors = resErr;
  //     }
  //   )
  // }

  getReceipt(receipt_no) {
    this.recLoad = true;
    this.sample
    .printReciept(receipt_no)
    .subscribe(
      (resSuccess) => {
        this.recLoad = false
        this.receipt = resSuccess
        console.log(this.receipt)
      },
      (resErr) => {
        this.Errors = resErr;
        this.recLoad = false
      }
    )
  }
  getPayment(bill_id) {
    console.log(bill_id)
    this.sample
    .getPayments(bill_id)
    .subscribe(
      (resSuccess) => {
        this.payment = resSuccess
        console.log(resSuccess)
        console.log(this.payment)
      },
      (resErr) => {
        this.Errors = resErr;
        console.log(resErr);

      }
    )
  }

  // getTemplate(result_id) {
  //   this.sample
  //   .getPrintResult(result_id)
  //   .subscribe(
  //     (resSuccess) => {
  //       this.tempLoad = false
  //       this.templates = resSuccess
  //       this.Template_Text = this.templates.data.test_body
  //       // console.log(resSuccess)
  //     },
  //     (resErr) => {
  //       this.tempLoad = false
  //       this.Errors = resErr;
  //     }
  //   )
  // }
  addRecord(item) {
    this.mode = "rec"
    this.tempLoad = true
    // this.getTemplate(item.result_id)
    this.record = item
    this.getPayment(item.bill_no)
    this.getReceipt(item.receipt_no)
    this.Errors = ""
    this.item = item
    console.log(item)
  }

  back() {
    this.mode = "form"
    this.payment = ""
    this.Template_Text = ""
    this.receipt = ""
  }
  setReceipt() {
    this.mode = "rec"
  }
  done() {
    this.mode = "form"
    this.stateForm.patchValue({
      formatstr: this.Template_Text
    });
    console.log(this.stateForm.value)
    this._snackBar.open('Template Added Successfully', '', {
      duration: 2000,
      verticalPosition: 'top',
    });
  }
  setTemplate(template) {
    this.Template_Text = template.Template_Text
  }

  refund() {
    const data = { bill_id: this.item.bill_id, receipt_id: this.item.receipt_id, receipt_no: this.item.receipt_no };
    this.modal.openModal(RefundComponent, 'modal', data);
    console.log(data);


  }

  onSubmit(e) {
    // e.preventDefault();
    console.log(this.stateForm.value)
    this.isSaveLoading = true;
    this.Errors = null;
    this.Success = null;
    let is_finalized = true;
    const {
      sample_id,
      format_code,
      formatstr,
      result_id
    } = this.stateForm.value;
    this.sample
      .postResultTemplate(
        sample_id,
        format_code,
        formatstr
      )
      .subscribe(
        (resSuccess) => {

          this.message = resSuccess
          this.isSaveLoading = false;
          this.stateForm.reset()

          if (this.message.success) {
            // this.getResult()
            this._snackBar.open('Saved Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          }
          else {
            this.Errors = "Not successful, please try again"
            console.log("Error Please Try Agian")
            this._snackBar.open('Error Please Try Agian', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          }

        },
        (resErr) => {
          this.isSaveLoading = false;
          this.Errors = resErr;
          console.log(resErr)
        }
      );
      this.sample
        .postResultFinalize(
          result_id,
          is_finalized,
        )
        .subscribe(
          (resSuccess) => {

            this.message = resSuccess
            this.isSaveLoading = false;
            this.stateForm.reset()

            if (this.message.success) {
              // this.getResult()
              this._snackBar.open('Saved Successfully', '', {
                duration: 2000,
                verticalPosition: 'top',
              });
            }
            else {
              this.Errors = "Not successful, please try again"
              console.log("error")
            }

          },
          (resErr) => {
            this.isSaveLoading = false;
            this.Errors = resErr;
            console.log(resErr)
          }
        );
  }

  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <style>
          #print-section {
            width: 500px;
          }
          </style>
        </head>
    <body onload="window.print()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
}

printResult(): void {
  let printContents, popupWin;
    printContents = document.getElementById('receipt').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <style>
          #receipt {
            width: 500px;
            margin-left: 100px;
          }
          </style>
        </head>
    <body onload="window.print()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
}

makeVisible() {
  this.visible = !this.visible
}

startDateChange(event: any) {
  this.startdate = (moment(event.target.value).format('YYYY-MM-DD'));
  console.log(this.startdate, this.name);

  }
  endDateChange(event: any) {
    this.enddate = (moment(event.target.value).format('YYYY-MM-DD'));
    console.log(this.enddate);

  }

}
